export default __webpack_public_path__ + "static/media/Pool-Lounge.82d42d12.webp";